module.exports = __webpack_public_path__ + "img/icon_img06.64e38c55.png";